import { render, staticRenderFns } from "./InternalNotes.vue?vue&type=template&id=5a724418&scoped=true&"
import script from "./InternalNotes.vue?vue&type=script&lang=js&"
export * from "./InternalNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a724418",
  null
  
)

export default component.exports